import type { ReactNode } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import useId from "@/hooks/useId";
import type { DefaultComponentProps } from "@/types/component.types";
import cn from "@/utils/cn";
import styles from "./Tooltip.module.css";

export interface TooltipProps extends DefaultComponentProps {
    readonly id?: string;
    readonly content: string | Element | ReactNode;
    readonly children?: ReactNode;
    readonly place?: "top" | "bottom" | "left" | "right";
}

function Tooltip({
    children,
    className,
    content,
    id,
    place = "top",
    testId,
}: TooltipProps) {
    const isAnchoredByChild = Boolean(children);
    const tooltipId = useId(id);

    return (
        <div
            className={styles.container}
            id={isAnchoredByChild ? tooltipId : undefined}
        >
            {children}
            <ReactTooltip
                anchorSelect={isAnchoredByChild ? `#${tooltipId}` : undefined}
                border="1px solid var(--sd-border-color-subtle)"
                className={cn(styles.tooltip, className)}
                data-testid={testId}
                id={!isAnchoredByChild ? tooltipId : undefined}
                place={place}
            >
                {content}
            </ReactTooltip>
        </div>
    );
}

export default Tooltip;
